import { createTheme } from "@mui/material";

export const theme = createTheme({
    palette: {
        primary: {
            main: "#186480",
            light: "#bad1d9",
            dark: "#0e3c4d"
        },
        secondary: {
            main:"#E0801E",
            light: "#f6d9bc",
            dark: "#5a330c"
        },
        // text: {
        //     primary: "",
        //     secondary: "",
        //     disabled: ""
        // },
        background: {
            paper: "#fff",
            default: "#f0f0f0"
        },
    },
    shape: {
        borderRadius: 12
    },
    typography: {
        fontFamily: "'Poppins', 'Roboto', 'Arial', 'sans-serif'",
    },
    components: {
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: "#bad1d9",
                    background: "linear-gradient(135deg, #186480 0%, #f6d9bc 100%)",
                    color: "black",
                    border: "none",
                },
            }
        }
    }
})